// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { OrderTypeBaseParameters } from '@shared/commons/cache/OrderParams/order-type/OrderTypeBaseParameters';
class _TifUtils {
    getAllowedTifsForTrading(account, instrument, orderType) {
        let allowedTifs = new Array();
        if (isNullOrUndefined(instrument) || isNullOrUndefined(orderType)) {
            return allowedTifs;
        }
        const DataCache = instrument.DataCache;
        if (isNullOrUndefined(DataCache) || DataCache.OrderParameterContainer === null) {
            return allowedTifs;
        }
        const supportedParamObj = new OrderTypeBaseParameters(instrument, account);
        const currentOrderType = DataCache.OrderParameterContainer.GetOrderType(orderType);
        if (isNullOrUndefined(currentOrderType)) {
            return allowedTifs;
        }
        if (!currentOrderType.IsSupported(supportedParamObj)) {
            return allowedTifs;
        }
        const allowedTifsFromSession = instrument.GetAllowedTifs();
        if (!isValidArray(allowedTifsFromSession)) {
            return allowedTifs;
        }
        const route = DataCache.Routes.getRouteByName(instrument.Route);
        if (isNullOrUndefined(route)) {
            return allowedTifs;
        }
        const tifsFromRoute = route.DictOrderTypeTifs[orderType];
        if (!isValidArray(tifsFromRoute)) {
            return allowedTifs;
        }
        allowedTifs = allowedTifsFromSession.filter((tif) => tifsFromRoute.includes(tif));
        return allowedTifs;
    }
}
export const TifUtils = new _TifUtils();
